import {TranslateService} from '@ngx-translate/core';
import {DOCUMENT_MAX_MB, isDocumentTooLargeError} from '@maporium-workspace/shared';
import {NotificationService} from '../services/notification.service';

// A PDF can be rejected as "too large" by several independent checks:
//   - the client-side byte guard before the S3 upload (openai.service),
//   - the backend's 413 on the presign / preflight / convert endpoints,
//   - the preflight `too_large` verdict (context-token budget),
//   - the async job failing with the PDF_TOO_LARGE sentinel.
// MAP-1405 AC3 wants one title/message for all of them, so every path goes
// through this helper instead of echoing a raw backend string.
export const PDF_TOO_LARGE_JOB_PREFIX = 'PDF_TOO_LARGE:';

export function showPdfTooLargeNotification(
  notificationService: NotificationService,
  translate: TranslateService,
  // Job id when the rejection came from a tracked job, so this notification
  // supersedes the "import in progress" one still on screen (MAP-1579).
  taskKey?: string
): void {
  notificationService.error(
    translate.instant('CREATE_MAP_DIALOG.PDF_TOO_LARGE_SIZE_MESSAGE', {maxSizeMb: DOCUMENT_MAX_MB}),
    {title: translate.instant('CREATE_MAP_DIALOG.PDF_CANNOT_SMAP_TITLE'), duration: 0, taskKey}
  );
}

export function isPdfTooLargeError(error: unknown): boolean {
  return isDocumentTooLargeError(error);
}
